import React from 'react';

export interface CallbackContextType {
  callback: () => Promise<void> ;
  setCallback: (callback: () => () => Promise<void>) => void;
}

export default React.createContext<CallbackContextType>(undefined);
